function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { parseSelector } from 'vega-event-selector';
import { array, isObject, isString, stringValue } from 'vega-util';
import { isTimerSelection, selectionCompilers, STORE } from '.';
import { warn } from '../../log';
import { duplicate, entries, replacePathInField, varName } from '../../util';
import { OutputNode } from '../data/dataflow';
import { FilterNode } from '../data/filter';
import { DataSourceType } from '../../data';
import { MULTIPLE_TIMER_ANIMATION_SELECTION, selectionAsScaleDomainWithoutField, selectionAsScaleDomainWrongEncodings } from '../../log/message';
export function parseUnitSelection(model, selDefs) {
  var selCmpts = {};
  var selectionConfig = model.config.selection;
  if (!selDefs || !selDefs.length) return selCmpts;
  var nTimerSelections = 0;
  var _iterator = _createForOfIteratorHelper(selDefs),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var def = _step.value;
      var name = varName(def.name);
      var selDef = def.select;
      var type = isString(selDef) ? selDef : selDef.type;
      var defaults = isObject(selDef) ? duplicate(selDef) : {
        type: type
      };
      // Set default values from config if a property hasn't been specified,
      // or if it is true. E.g., "translate": true should use the default
      // event handlers for translate. However, true may be a valid value for
      // a property (e.g., "nearest": true).
      var cfg = selectionConfig[type];
      for (var key in cfg) {
        // Project transform applies its defaults.
        if (key === 'fields' || key === 'encodings') {
          continue;
        }
        if (key === 'mark') {
          defaults.mark = _objectSpread(_objectSpread({}, cfg.mark), defaults.mark);
        }
        if (defaults[key] === undefined || defaults[key] === true) {
          var _cfg$key;
          defaults[key] = duplicate((_cfg$key = cfg[key]) !== null && _cfg$key !== void 0 ? _cfg$key : defaults[key]);
        }
      }
      var selCmpt = selCmpts[name] = _objectSpread(_objectSpread({}, defaults), {}, {
        name: name,
        type: type,
        init: def.value,
        bind: def.bind,
        events: isString(defaults.on) ? parseSelector(defaults.on, 'scope') : array(duplicate(defaults.on))
      });
      if (isTimerSelection(selCmpt)) {
        nTimerSelections++;
        // check for multiple timer selections and ignore all but the first one
        if (nTimerSelections > 1) {
          delete selCmpts[name];
          continue;
        }
      }
      var def_ = duplicate(def); // defensive copy to prevent compilers from causing side effects
      var _iterator2 = _createForOfIteratorHelper(selectionCompilers),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var c = _step2.value;
          if (c.defined(selCmpt) && c.parse) {
            c.parse(model, selCmpt, def_);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (nTimerSelections > 1) {
    // if multiple timer selections were found, issue a warning
    warn(MULTIPLE_TIMER_ANIMATION_SELECTION);
  }
  return selCmpts;
}
export function parseSelectionPredicate(model, pred, dfnode) {
  var datum = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'datum';
  var name = isString(pred) ? pred : pred.param;
  var vname = varName(name);
  var store = stringValue(vname + STORE);
  var selCmpt;
  try {
    selCmpt = model.getSelectionComponent(vname, name);
  } catch (e) {
    // If a selection isn't found, treat as a variable parameter and coerce to boolean.
    return "!!".concat(vname);
  }
  if (selCmpt.project.timeUnit) {
    var child = dfnode !== null && dfnode !== void 0 ? dfnode : model.component.data.raw;
    var tunode = selCmpt.project.timeUnit.clone();
    if (child.parent) {
      tunode.insertAsParentOf(child);
    } else {
      child.parent = tunode;
    }
  }
  var fn = selCmpt.project.hasSelectionId ? 'vlSelectionIdTest(' : 'vlSelectionTest(';
  var resolve = selCmpt.resolve === 'global' ? ')' : ", ".concat(stringValue(selCmpt.resolve), ")");
  var test = "".concat(fn).concat(store, ", ").concat(datum).concat(resolve);
  var length = "length(data(".concat(store, "))");
  return pred.empty === false ? "".concat(length, " && ").concat(test) : "!".concat(length, " || ").concat(test);
}
export function parseSelectionExtent(model, name, extent) {
  var vname = varName(name);
  var encoding = extent.encoding;
  var field = extent.field;
  var selCmpt;
  try {
    selCmpt = model.getSelectionComponent(vname, name);
  } catch (e) {
    // If a selection isn't found, treat it as a variable parameter.
    return vname;
  }
  if (!encoding && !field) {
    field = selCmpt.project.items[0].field;
    if (selCmpt.project.items.length > 1) {
      warn(selectionAsScaleDomainWithoutField(field));
    }
  } else if (encoding && !field) {
    var encodings = selCmpt.project.items.filter(function (p) {
      return p.channel === encoding;
    });
    if (!encodings.length || encodings.length > 1) {
      field = selCmpt.project.items[0].field;
      warn(selectionAsScaleDomainWrongEncodings(encodings, encoding, extent, field));
    } else {
      field = encodings[0].field;
    }
  }
  return "".concat(selCmpt.name, "[").concat(stringValue(replacePathInField(field)), "]");
}
export function materializeSelections(model, main) {
  var _model$component$sele;
  var _iterator3 = _createForOfIteratorHelper(entries((_model$component$sele = model.component.selection) !== null && _model$component$sele !== void 0 ? _model$component$sele : {})),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _ref = _step3.value;
      var _ref2 = _slicedToArray(_ref, 2);
      var selection = _ref2[0];
      var selCmpt = _ref2[1];
      var lookupName = model.getName("lookup_".concat(selection));
      model.component.data.outputNodes[lookupName] = selCmpt.materialized = new OutputNode(new FilterNode(main, model, {
        param: selection
      }), lookupName, DataSourceType.Lookup, model.component.data.outputNodeRefCounts);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
}